import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { map, take } from 'rxjs';
import { AuthService } from './auth.service';
import { consumePreviewReturnUrl, rememberPreviewReturnUrl, validatePreviewReturnUrl } from './preview-return-url';

export function supportLoginGuard(route: ActivatedRouteSnapshot) {
  const auth = inject(AuthService);
  const returnUrl = validatePreviewReturnUrl(route.queryParamMap.get('returnUrl'));
  if (returnUrl) {
    rememberPreviewReturnUrl(returnUrl);
  }

  return auth.user.pipe(
    take(1),
    map(user => {
      if (!(user && auth.isSupportUser(user))) {
        return true;
      }
      const previewReturn = consumePreviewReturnUrl();
      if (previewReturn) {
        window.location.assign(previewReturn);
        return false;
      }
      return auth.getHomeUrlTree(user);
    })
  );
}
